// extracted by mini-css-extract-plugin
export default {"image":"MV2yYE"};